// import { RootStore } from 'mobx-stores'
import { PaginationSearchBase, TriggerSearchFunc } from "mobx-stores/utils";
import { Api } from "services";
import { ApiKeyDTO, ApiKeyFilterDTO } from "../../../models/api-key";
import { RootStore } from "../../root-store/root-store";
import {
  ApiKeysTableSearchProps,
  ApiKeysTableSortProps,
} from "./api-keys-table-store.types";
import {
  apiKeysTableNeedTimeoutSearchProps,
  initialApiKeysTablePaginationProps,
  initialApiKeysTableSearchProps,
} from "./api-keys-table-store.utils";

export class ApiKeysTableStore extends PaginationSearchBase<
  ApiKeysTableSortProps,
  ApiKeysTableSearchProps,
  ApiKeyDTO
> {
  private rootStore: RootStore;
  private apiKeysApi: Api["apiKeysApi"];

  constructor(rootStore: any) {
    super({
      initialPaginationProps: initialApiKeysTablePaginationProps,
      initialSearchProps: initialApiKeysTableSearchProps,
      needTimeoutProps: apiKeysTableNeedTimeoutSearchProps,
    });
    this.rootStore = rootStore;
    this.apiKeysApi = rootStore.generalStore.api.apiKeysApi;
  }

  // METHODS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    const data = await this.apiKeysApi.getApiKeysFiltered(this.apiKeyFilter, {
      pageQueryParams: {
        page: options?.resetPageNumber ? 0 : this.pagination.page,
        size: this.pagination.size,
        sortDirection: this.pagination.sortDirection,
        sortProp: this.pagination.sortProp,
      },
    });
    if (!data) return;
    this.handleSearchResultPaginationProps(data);
    this.setSearchResults(data.content);
  };

  public regenerateApiKey = async (storeId: number): Promise<void> => {
    const data = await this.apiKeysApi.regenerateApiKey(storeId);
    if (!data) return;
    await this.triggerSearch();
    this.rootStore.generalStore.showSuccess("API key regenerated");
  };

  public generateApiKey = async (): Promise<void> => {
    const data = await this.apiKeysApi.autoGenerateApiKey();
    if (!data) return;
    await this.triggerSearch({ resetPageNumber: true });
    this.rootStore.generalStore.showSuccess("API keys generated");
  };

  // COMPUTED
  private get apiKeyFilter(): ApiKeyFilterDTO {
    return {
      storeName: this.searchProps.storeName,
    };
  }
}
